import { KeyMultipleRegular, PeopleRegular, ShieldKeyholeRegular, ShieldPersonRegular, StethoscopeRegular, } from '@fluentui/react-icons';
export const adminModule = {
    path: 'admin',
    title: 'Administração',
    icon: ShieldPersonRegular,
    placement: 'footer',
    pages: [
        {
            path: 'usuarios',
            title: 'Usuários',
            description: 'Quem tem acesso, com quais perfis, e o app no Teams de cada um.',
            icon: PeopleRegular,
            permission: 'Users.Read',
            load: () => import('#src/modules/admin/UsersPage.js').then((m) => m.UsersPage),
        },
        {
            path: 'perfis',
            title: 'Perfis',
            description: 'O que cada perfil permite fazer no app.',
            icon: ShieldKeyholeRegular,
            permission: 'Roles.Read',
            load: () => import('#src/modules/admin/RolesPage.js').then((m) => m.RolesPage),
        },
        {
            path: 'permissoes',
            title: 'Permissões',
            description: 'Todas as permissões do app: o que cada uma libera e exige.',
            icon: KeyMultipleRegular,
            permission: 'Permissions.Read',
            load: () => import('#src/modules/admin/PermissionsPage.js').then((m) => m.PermissionsPage),
        },
        {
            path: 'diagnostico',
            title: 'Diagnóstico',
            description: 'Confira se o bot consegue enviar para qualquer pessoa.',
            icon: StethoscopeRegular,
            permission: 'Diagnostics.Read',
            load: () => import('#src/modules/admin/DiagnosticsPage.js').then((m) => m.DiagnosticsPage),
        },
    ],
    routes: [
        {
            path: 'usuarios/:id',
            title: 'Usuário',
            permission: 'Users.Read',
            load: () => import('#src/modules/admin/UserPage.js').then((m) => m.UserPage),
        },
        {
            path: 'perfis/:code',
            title: 'Perfil',
            permission: 'Roles.Read',
            load: () => import('#src/modules/admin/RolePage.js').then((m) => m.RolePage),
        },
        {
            path: 'permissoes/:key',
            title: 'Permissão',
            permission: 'Permissions.Read',
            load: () => import('#src/modules/admin/PermissionPage.js').then((m) => m.PermissionPage),
        },
    ],
};
//# sourceMappingURL=admin.module.js.map